import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper";

export const getCountryStateDefinition = () => get(url.COUNTRY_STATE_DEFINITIONS);
export const addCountryStateDefinition = record => post(url.COUNTRY_STATE_INSERT, record);
export const updateCountryStateDefinition = record => put(url.COUNTRY_STATE_UPDATE, record);
export const deleteCountryStateDefinition = guid => del(url.COUNTRY_STATE_DELETE, { params: { guid } });